<template>
  <div id='bd-common'>
    <el-checkbox v-model="shouldPlayAudio" @change="onPlayAudioChange" style="margin-left: 50px;">{{ $t('playAudio') }}</el-checkbox><br>
    <el-checkbox v-model="shouldShowNotificationWindow" @change="onShowNotificationWindowChange" style="margin-left: 50px;">{{ $t('showNotificationWindow') }}</el-checkbox><br>
    <el-checkbox v-model="showBottomStatistics" @change="onShowBottomStatisticChange" style="margin-left: 50px;">{{ $t('showBottomStatistics') }}</el-checkbox><br>
    <el-checkbox v-model="showOutOfTime" @change="onShowOutOfTimeChange" style="margin-left: 50px;">{{ $t('showOutOfTime') }}</el-checkbox><br>
    <el-checkbox v-model="shouldShowInputTips" @change="onShowInputTipsChange" style="margin-left: 50px;">{{ $t('showInputTip') }}</el-checkbox><br>
    <el-checkbox v-model="showNetworkStatus" @change="onNetworkStatusChange" style="margin-left: 50px;">{{ $t('showNetworkStatus') }}</el-checkbox><br>
    <el-checkbox v-model="shouldQueryMpQrcodeUrl" @change="onQueryMpQrcodeUrlChange" style="margin-left: 50px;">{{ $t('queryMpQrcodeUrl') }}</el-checkbox><br>
    <el-checkbox v-model="shouldWechatMpPush" @change="onWechatMpPushChange" style="margin-left: 50px;">{{ $t('wechatMpPushStatus') }}</el-checkbox><br>
    <span style="margin-left: 50px;">{{ version }}</span>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
const constants = require('@/util/constants')
// import bus from '@/util/eventbus'

export default {
  name: 'bd-common',
  data () {
    return {
      version: process.env.VUE_APP_VERSION,
      // isIp: constants.IS_IP,
      // electron: constants.IS_ELECTRON,
      shouldPlayAudio: true,
      shouldShowNotificationWindow: true,
      showBottomStatistics: true,
      showOutOfTime: true,
      shouldShowInputTips: true,
      shouldQueryMpQrcodeUrl: true,
      showNetworkStatus: true,
      shouldWechatMpPush: true
    }
  },
  computed: {
    ...mapGetters([ 'isWechatMpBinded', 'isWechatMpPushEnabled' ]), // 'userInfo', 
  },
  methods: {
    ...mapActions([
      'updateProfile',
      'updateShowBottomStatistics',
      'updateShowOutOfTime',
      'updateShowInputTips',
      'updateQueryMpQrcodeUrl',
      'updateShowNetworkStatus',
      'updateWechatMpPushStatus'
    ]),
    // 监听播放声音设置
    onPlayAudioChange (value) {
      // console.log('check:', value)
      Vue.ls.set(constants.PLAY_AUDIO, value)
    },
    onShowNotificationWindowChange (value) {
      // console.log('check:', value)
      Vue.ls.set(constants.SHOW_NOTIFICATION_WINDOW, value)
    },
    onShowBottomStatisticChange (value) {
      // console.log('statistic check:', value)
      Vue.ls.set(constants.SHOW_BOTTOM_STATISTIC, value)
      this.updateShowBottomStatistics(value)
    },
    onShowOutOfTimeChange (value) {
      // console.log('out of time check:', value)
      Vue.ls.set(constants.SHOW_OUT_OF_TIME, value)
      this.updateShowOutOfTime(value)
    },
    onShowInputTipsChange (value) {
      // console.log('input tips check:', value)
      Vue.ls.set(constants.SHOW_INPUT_TIPS, value)
      this.updateShowInputTips(value)
    },
    onQueryMpQrcodeUrlChange (value) {
      // console.log('onQueryMpQrcodeUrlChange check:', value)
      Vue.ls.set(constants.QUERY_MPQRCODE_URL, value)
      this.updateQueryMpQrcodeUrl(value)
    },
    onWechatMpPushChange(value) {
      console.log('onWechatMpPushChange check:', value)
      Vue.ls.set(constants.SHOULD_WECHAT_MP_PUSH, value)
      this.updateWechatMpPushStatus(value)
    },
    onNetworkStatusChange(value) {
      // console.log('onNetworkStatusChange check:', value)
      Vue.ls.set(constants.SHOW_NETWORK_STATUS, value)
      this.updateShowNetworkStatus(value)
    }
  },
  // mounted() {
  // },
  created() {
    this.shouldPlayAudio = Vue.ls.get(constants.PLAY_AUDIO, true)
    this.shouldShowNotificationWindow = Vue.ls.get(constants.SHOW_NOTIFICATION_WINDOW, true)
    this.showBottomStatistics = Vue.ls.get(constants.SHOW_BOTTOM_STATISTIC, true)
    this.showOutOfTime = Vue.ls.get(constants.SHOW_OUT_OF_TIME, false)
    this.shouldShowInputTips = Vue.ls.get(constants.SHOW_INPUT_TIPS, true)
    this.shouldQueryMpQrcodeUrl = Vue.ls.get(constants.QUERY_MPQRCODE_URL, true)
    this.showNetworkStatus = Vue.ls.get(constants.SHOW_NETWORK_STATUS, true)
    this.shouldWechatMpPush = Vue.ls.get(constants.SHOULD_WECHAT_MP_PUSH, true)
  },
}
</script>

<style scoped>
#bd-common {
  height: 100%;
  overflow: auto;
  text-align: left;
  padding-top: 20px;
}
</style>
